var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6c825187"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "columns" };
const _hoisted_2 = {
    key: 0,
    class: "column is-one-third"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "notification bulmaNotification is-info" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Notarization is not required for this application.")
], -1));
const _hoisted_4 = {
    key: 1,
    class: "column is-one-third"
};
const _hoisted_5 = { style: { "text-align": "left" } };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "pipe pipeDown" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "dot" })
], -1));
const _hoisted_7 = { class: "phase" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "pipe pipeBoth" }, null, -1));
const _hoisted_10 = { class: "description" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label mt-3" }, "1. Download Blank Form", -1));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-download mr-3" }, null, -1));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label mt-3" }, "2. Upload Signed Form", -1));
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "pipe pipeBoth" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "dot" })
], -1));
const _hoisted_15 = { class: "phase" };
const _hoisted_16 = { key: 1 };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "pipe pipeBoth" }, null, -1));
const _hoisted_18 = { class: "description" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label mt-3" }, "1. Download Signed Form", -1));
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-download mr-3" }, null, -1));
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label mt-3" }, "2. Upload Notarized Form", -1));
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "pipe pipeUp" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "dot" })
], -1));
const _hoisted_23 = { class: "phase" };
const _hoisted_24 = { key: 2 };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "pipe" }, null, -1));
const _hoisted_26 = { class: "description" };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label mt-3" }, "Notarization process is complete!", -1));
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-download mr-3" }, null, -1));
const _hoisted_29 = { class: "column is-narrow" };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Filling date to be used for application:", -1));
const _hoisted_31 = { key: 0 };
const _hoisted_32 = { key: 1 };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, " This will reset the notarization process for this application, and notaries will be contacted again via email to request notarization of the new signed form. ", -1));
import { doApiAction } from "@/core/api";
import { onMounted, ref } from "vue";
import { apiBirthRecords } from "../api";
import FormDateField from "@/components/FormDateField.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BirthRecordNotarizationTracker',
    props: {
        request: {}
    },
    setup(__props) {
        const props = __props;
        const notarizationRequired = ref();
        const signedForm = ref();
        const notarizedForm = ref();
        const fillingDate = ref();
        const openedSection = ref(null);
        const signedFormPendingUpload = ref(null);
        const inProgressAction = ref(null);
        const openActiveSection = () => {
            if (notarizedForm.value) {
                openedSection.value = "complete";
            }
            else if (signedForm.value) {
                openedSection.value = "notarize";
            }
            else {
                openedSection.value = "sign";
            }
        };
        onMounted(() => {
            notarizationRequired.value = props.request.notarizationRequired;
            signedForm.value = props.request.signedNotaryForm;
            notarizedForm.value = props.request.notarizedNotaryForm;
            fillingDate.value = props.request.fillingDate;
            openActiveSection();
        });
        const setNotarizationRequired = (required) => {
            doApiAction(inProgressAction, 'setNotarizationRequired', "Notarization requirement updated", "Failed to update notarization requirement", () => __awaiter(this, void 0, void 0, function* () {
                yield apiBirthRecords.setNotarizationRequired(props.request.id, required)
                    .then(resp => {
                    notarizationRequired.value = required;
                });
            }));
        };
        const downloadBlankForm = () => {
            doApiAction(inProgressAction, "downloadBlankForm", null, "Failed to download blank notary form", () => apiBirthRecords.getBlankNotaryFormViewLink(props.request.id).then((link) => window.open(link)));
        };
        const uploadSignedForm = (uploadInfo) => {
            if (signedForm.value) {
                signedFormPendingUpload.value = uploadInfo;
            }
            else {
                doUploadSignedForm(uploadInfo);
            }
        };
        const cancelUploadSignedForm = () => {
            signedFormPendingUpload.value.onDone();
            signedFormPendingUpload.value = null;
        };
        const doUploadSignedForm = (uploadInfo) => {
            signedFormPendingUpload.value = null;
            doApiAction(inProgressAction, "uploadSignedForm", "Signed notary form PDF uploaded", "Failed to upload signed notary form", () => apiBirthRecords.uploadSignedNotaryForm(props.request.id, uploadInfo.file)
                .then((doc) => { signedForm.value = doc; notarizedForm.value = undefined; openActiveSection(); })
                .finally(() => uploadInfo.onDone()));
        };
        const uploadNotarizedForm = (uploadInfo) => {
            doApiAction(inProgressAction, "uploadNotarizedForm", "Notarized notary form PDF uploaded", "Failed to upload notarized notary form", () => apiBirthRecords.uploadNotarizedNotaryForm(props.request.id, uploadInfo.file)
                .then((doc) => { notarizedForm.value = doc; fillingDate.value = new Date(); openActiveSection(); })
                .finally(() => uploadInfo.onDone()));
        };
        const downloadForm = (doc) => {
            doApiAction(inProgressAction, "downloadNotaryForm", null, "Failed to download notary form", () => apiBirthRecords.getAttachmentViewLink(props.request.id, doc.id).then((link) => window.open(link)));
        };
        const deleteNotaryForm = (doc) => {
            doApiAction(inProgressAction, "deleteNotaryForm", null, "Failed to delete notary form", () => apiBirthRecords.deleteAttachment(props.request.id, doc.id).
                then(() => {
                if (signedForm.value == doc) {
                    signedForm.value = undefined;
                }
                if (notarizedForm.value == doc) {
                    notarizedForm.value = undefined;
                }
                openActiveSection();
            }));
        };
        const setFillingDate = (date) => {
            doApiAction(inProgressAction, "setFillingDate", "Saved filling date", "Failed to save filling date", () => apiBirthRecords.setFillingDate(props.request.id, fillingDate.value));
        };
        return (_ctx, _cache) => {
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_DocumentUploadButton = _resolveComponent("DocumentUploadButton");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    (!_ctx.request.notarizationRequired)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _hoisted_3,
                            _createVNode(_component_SaveButton, {
                                label: "Enable Notarization",
                                icon: "fa-plus",
                                action: "setNotarizationRequired",
                                inProgressAction: inProgressAction.value,
                                onClick: _cache[0] || (_cache[0] = ($event) => (setNotarizationRequired(true)))
                            }, null, 8, ["inProgressAction"])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("table", _hoisted_5, [
                                _createElementVNode("tr", null, [
                                    _hoisted_6,
                                    _createElementVNode("td", _hoisted_7, [
                                        _createTextVNode(" Sign "),
                                        (openedSection.value == 'sign')
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                onClick: _cache[1] || (_cache[1] = ($event) => (openedSection.value = null)),
                                                class: "toggleButton fas fa-chevron-up"
                                            }))
                                            : (_openBlock(), _createElementBlock("i", {
                                                key: 1,
                                                onClick: _cache[2] || (_cache[2] = ($event) => (openedSection.value = 'sign')),
                                                class: "toggleButton fas fa-chevron-down"
                                            }))
                                    ])
                                ]),
                                (openedSection.value == 'sign')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                                        _hoisted_9,
                                        _createElementVNode("td", _hoisted_10, [
                                            _hoisted_11,
                                            _createElementVNode("a", {
                                                class: _normalizeClass(["button is-link", { 'is-loading': inProgressAction.value == 'downloadBlankForm' }]),
                                                onClick: _cache[3] || (_cache[3] = ($event) => (downloadBlankForm()))
                                            }, [
                                                _hoisted_12,
                                                _createTextVNode(" Download Blank Form ")
                                            ], 2),
                                            _hoisted_13,
                                            _createVNode(_component_DocumentUploadButton, {
                                                document: signedForm.value,
                                                onUpload: uploadSignedForm,
                                                label: signedForm.value ? 'Replace Signed Form' : 'Upload Signed Form'
                                            }, null, 8, ["document", "label"])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("tr", {
                                    class: _normalizeClass(signedForm.value ? '' : 'FUTURE')
                                }, [
                                    _hoisted_14,
                                    _createElementVNode("td", _hoisted_15, [
                                        _createTextVNode(" Notarize "),
                                        (signedForm.value && openedSection.value == 'notarize')
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                onClick: _cache[4] || (_cache[4] = ($event) => (openedSection.value = null)),
                                                class: "toggleButton fas fa-chevron-up"
                                            }))
                                            : (signedForm.value)
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 1,
                                                    onClick: _cache[5] || (_cache[5] = ($event) => (openedSection.value = 'notarize')),
                                                    class: "toggleButton fas fa-chevron-down"
                                                }))
                                                : _createCommentVNode("", true)
                                    ])
                                ], 2),
                                (signedForm.value && openedSection.value == 'notarize')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                                        _hoisted_17,
                                        _createElementVNode("td", _hoisted_18, [
                                            _hoisted_19,
                                            _createElementVNode("a", {
                                                class: _normalizeClass(["button is-link", { 'is-loading': inProgressAction.value == 'downloadSignedForm' }]),
                                                onClick: _cache[6] || (_cache[6] = ($event) => (downloadForm(signedForm.value)))
                                            }, [
                                                _hoisted_20,
                                                _createTextVNode(" Download Signed Form ")
                                            ], 2),
                                            _hoisted_21,
                                            _createVNode(_component_DocumentUploadButton, {
                                                document: notarizedForm.value,
                                                onUpload: uploadNotarizedForm,
                                                label: notarizedForm.value ? 'Replace Notarized Form' : 'Upload Notarized Form'
                                            }, null, 8, ["document", "label"])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("tr", {
                                    class: _normalizeClass(notarizedForm.value ? '' : 'FUTURE')
                                }, [
                                    _hoisted_22,
                                    _createElementVNode("td", _hoisted_23, [
                                        _createTextVNode(" Complete "),
                                        (notarizedForm.value && openedSection.value == 'complete')
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                onClick: _cache[7] || (_cache[7] = ($event) => (openedSection.value = null)),
                                                class: "toggleButton fas fa-chevron-up"
                                            }))
                                            : (notarizedForm.value)
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 1,
                                                    onClick: _cache[8] || (_cache[8] = ($event) => (openedSection.value = 'complete')),
                                                    class: "toggleButton fas fa-chevron-down"
                                                }))
                                                : _createCommentVNode("", true)
                                    ])
                                ], 2),
                                (notarizedForm.value && openedSection.value == 'complete')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                                        _hoisted_25,
                                        _createElementVNode("td", _hoisted_26, [
                                            _hoisted_27,
                                            _createElementVNode("a", {
                                                class: _normalizeClass(["button is-link", { 'is-loading': inProgressAction.value == 'downloadNotarizedForm' }]),
                                                onClick: _cache[9] || (_cache[9] = ($event) => (downloadForm(notarizedForm.value)))
                                            }, [
                                                _hoisted_28,
                                                _createTextVNode(" Download Final Notarized Form ")
                                            ], 2)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])),
                    _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createVNode(FormDateField, {
                            modelValue: fillingDate.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((fillingDate).value = $event)),
                            past: ""
                        }, null, 8, ["modelValue"]),
                        (fillingDate.value)
                            ? (_openBlock(), _createBlock(_component_SaveButton, {
                                key: 0,
                                icon: "fa-save",
                                label: "Save Filling Date",
                                action: "setFillingDate",
                                inProgressAction: inProgressAction.value,
                                onClick: _cache[11] || (_cache[11] = ($event) => (setFillingDate(fillingDate.value)))
                            }, null, 8, ["inProgressAction"]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createVNode(_component_ModalDialog, {
                    active: signedFormPendingUpload.value != null,
                    title: "Reset Notarization Process",
                    severity: "danger",
                    allowClose: true,
                    onClose: _cache[12] || (_cache[12] = ($event) => (cancelUploadSignedForm())),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[13] || (_cache[13] = ($event) => (cancelUploadSignedForm())),
                    secondButtonText: "Replace Signed Form",
                    secondButtonSeverity: "danger",
                    onSecondbuttonselected: _cache[14] || (_cache[14] = ($event) => (doUploadSignedForm(signedFormPendingUpload.value)))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", null, [
                            (notarizedForm.value)
                                ? (_openBlock(), _createElementBlock("strong", _hoisted_31, " This form has already been notarized - do you wish to upload a new signed form? "))
                                : (_openBlock(), _createElementBlock("strong", _hoisted_32, " A signed form has already been uploaded - do you wish to replace it? "))
                        ]),
                        _hoisted_33
                    ]),
                    _: 1
                }, 8, ["active"])
            ], 64));
        };
    }
});
